import { useFocusTrap } from "../common/helpers";

export const useSubscriptionForm = () => {
    const $el = document.querySelector("#subscription-form");

    const { setFocusTrap, removeFocusTrap } = useFocusTrap({ $el });

    const handleOpenSubscriptionForm = () => {
        if (!$el) {
            return;
        }

        const $closeButton = $el.querySelector(".js-ns-modal-close");

        setTimeout(() => {
            $closeButton.focus();

            setFocusTrap();
        }, 100);
    };

    const handleCloseSubscriptionForm = () => {
        if (!$el) {
            return;
        }

        removeFocusTrap();
    };

    return {
        handleOpenSubscriptionForm,
        handleCloseSubscriptionForm,
    };
};
